export default "__VITE_ASSET__ByyZgqco__"